<template>
  <div class="cm-field">
    <slot></slot>
  </div>
</template>

<script>
  import $ from 'jquery'
  import 'javascripts/select2'

  export default {
    mounted() {
      const selectTag = this.$el.querySelector('select')

      $(selectTag).select2({
        closeOnSelect: false
      })
    }
  }
</script>



// WEBPACK FOOTER //
// app/javascript/components/skills-field.vue?24cdf1e8